import React, { useState, useEffect } from "react";
import "./chat.css";
import MyChats from "./MyChats";
import { Box } from "@chakra-ui/react";
import { ChatState } from "../../context/ChatProvider";
import Chatbox from "../chat/Chatbox";
import Header3 from "../../components/Header3";
import Footer3 from "../../components/Footer3";

const Chatt = () => {
  const [fetchAgain, setFetchAgain] = useState(false);
  const { user,selectedChat} = ChatState();
  useEffect(() => {
    const element = document.getElementById("root");
    console.log(element.offsetWidth);
  }, []);

  const [heightStyle, setHeightStyle] = useState("100%");

  useEffect(() => {
    const screenHeight = window.innerHeight;

    if (screenHeight < 500) {
      setHeightStyle("100vh");
    } else {
      setHeightStyle("100%");
    }
  }, []);

  return (
    <div>
      <Header3 />
       <div className="  w-full bg-gradient-to-b from-white to-[#f7f7f7] p-4">
      <div className="mx-auto grid w-full max-w-[1100px] grid-cols-1 gap-4 md:grid-cols-[320px_1fr]">
          {user && <div className={`${!selectedChat ? "block" : "hidden"} md:block w-full`}><MyChats fetchAgain={fetchAgain} /></div>}
          {user && (
            <Chatbox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
          )}
       </div>
      </div>
      {/* <Footer3 /> */}
    </div >
  );
};

export default Chatt;
